var React = require('react');

function HamCloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"hamburger-top","d":"M0 1.75C0 0.783502 0.783502 0 1.75 0H23.25C24.2165 0 25 0.783502 25 1.75C25 2.7165 24.2165 3.5 23.25 3.5H1.75C0.783502 3.5 0 2.7165 0 1.75Z","fill":"var(--color-text-3)","key":0}),React.createElement("path",{"className":"hamburger-mid","d":"M0 10.748C0 9.78155 0.783502 8.99805 1.75 8.99805H23.25C24.2165 8.99805 25 9.78155 25 10.748C25 11.7145 24.2165 12.498 23.25 12.498H1.75C0.783502 12.498 0 11.7145 0 10.748Z","fill":"var(--color-text-3)","key":1})]);
}

HamCloseInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 25 22","fill":"none"};

module.exports = HamCloseInline;

HamCloseInline.default = HamCloseInline;
